/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksnameplaceholder3Inputs */

const en_downloadlinksnameplaceholder3 = /** @type {(inputs: Downloadlinksnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Cafeteria flyer or main square poster`)
};

const de_downloadlinksnameplaceholder3 = /** @type {(inputs: Downloadlinksnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Flyer Mensa oder Plakat Hauptplatz`)
};

/**
* | output |
* | --- |
* | "e.g. Cafeteria flyer or main square poster" |
*
* @param {Downloadlinksnameplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksnameplaceholder3 = /** @type {((inputs?: Downloadlinksnameplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksnameplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksnameplaceholder3(inputs)
	return de_downloadlinksnameplaceholder3(inputs)
});
export { downloadlinksnameplaceholder3 as "downloadLinksNamePlaceholder" }